// extracted by mini-css-extract-plugin
var _1 = "ITgP1";
var _2 = "DbZxT";
var _3 = "B2wUw";
export { _1 as "hidden", _2 as "loadingModalDescription", _3 as "loadingModalTitle" }
